"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { HeroHeader } from "@/components/hero-header/HeroHeader";
import { useCollectionBannerMedia, useCollectionBannerMediaFallback, useCollectionBannerMediaFallbackFragment, useCollectionBannerMediaFragment } from "../use-collection-banner-media";
import { CollectionHeaderContent, CollectionHeaderContentFragment } from "./CollectionHeaderContent";
export const CollectionHeaderFragment = graphql(`
    fragment CollectionHeader on Collection {
      slug
      ...CollectionHeaderContent
      ...useCollectionBannerMedia
      ...useCollectionBannerMediaFallback
    }
  `, [CollectionHeaderContentFragment, useCollectionBannerMediaFragment, useCollectionBannerMediaFallbackFragment]);
export function CollectionHeader(t0) {
  const $ = _c(13);
  let collectionKey;
  let rest;
  if ($[0] !== t0) {
    ({
      collection: collectionKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = collectionKey;
    $[2] = rest;
  } else {
    collectionKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== collectionKey) {
    t1 = readFragment(CollectionHeaderFragment, collectionKey);
    $[3] = collectionKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const collection = t1;
  const mediaUrl = useCollectionBannerMedia(collection);
  const fallbackImageUrl = useCollectionBannerMediaFallback(collection);
  const t2 = collection.slug === "ddust-by-jiwa" ? "png" : undefined;
  const t3 = mediaUrl ?? undefined;
  let t4;
  if ($[5] !== collection) {
    t4 = <CollectionHeaderContent collection={collection} />;
    $[5] = collection;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fallbackImageUrl || $[8] !== rest || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <HeroHeader fallbackImageUrl={fallbackImageUrl} isCollectionBanner={true} mediaFormat={t2} mediaUrl={t3} {...rest}>{t4}</HeroHeader>;
    $[7] = fallbackImageUrl;
    $[8] = rest;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}